/**
 * Helpers for viewing supporting documents in the browser (open in new tab)
 * instead of downloading. Used on Review Detail, IDP, and Dispute Management.
 */

const VIEWABLE_CONTENT_TYPES = new Set([
  'application/pdf',
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/gif',
  'text/plain',
  'text/csv',
]);

export function isViewableContentType(contentType: string): boolean {
  if (!contentType) return false;
  return VIEWABLE_CONTENT_TYPES.has(contentType.toLowerCase().trim());
}

/**
 * Opens a blob in a new browser tab so the user can view it (PDF, images, text).
 * Revokes the object URL after a delay so the tab has time to load.
 */
export function openBlobInNewTab(blob: Blob, _mimeType: string): void {
  const url = URL.createObjectURL(blob);
  window.open(url, '_blank', 'noopener,noreferrer');
  // Revoke after 5 min so the new tab has loaded; avoids leaking object URLs
  setTimeout(() => URL.revokeObjectURL(url), 5 * 60 * 1000);
}
